import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'q-ss-header-logo',
    templateUrl: './ss-header-logo.component.html',
    styleUrls: ['./ss-header-logo.component.scss']
})
export class SsHeaderLogoComponent implements OnInit {
    @Input() appName: string;
    @Input() isSplashPage: boolean;

    constructor() {}

    ngOnInit(): void {}
}
